// Stripe Price ID Mapping
// For Stripe-based paywall configurations
import { getEnvironmentTier } from '../utils/environment';

export const STRIPE_PRICES_MAP = {
  sandbox: {
    // Annual plans
    "com.shamruk.velvet.y130": null, // Annual - $130 (TODO: Add sandbox ID)

    // Monthly plans
    "com.shamruk.velvet.m40": null, // Monthly - $40 (TODO: Add sandbox ID)

    // 3-Month plans
    "com.shamruk.velvet.3m60": null, // 3 months - $60 (TODO: Add sandbox ID)

    // Discount coupons
    "com.shamruk.velvet.discount50": null, // 50% discount coupon (TODO: Add sandbox ID)
  },
  production: {
    // Annual plans
    "com.shamruk.velvet.y130": null, // Annual - $130 (TODO: Add production ID)

    // Monthly plans
    "com.shamruk.velvet.m40": null, // Monthly - $40 (TODO: Add production ID)

    // 3-Month plans
    "com.shamruk.velvet.3m60": null, // 3 months - $60 (TODO: Add production ID)

    // Discount coupons
    "com.shamruk.velvet.discount50": null, // 50% discount coupon (TODO: Add production ID)
  }
};

// Helper function to get Stripe price ID for current environment
export function getStripePriceId(productId: string): string | null {
  const env = getEnvironmentTier();
  return STRIPE_PRICES_MAP[env]?.[productId] || null;
}

// Validate if all required Stripe price IDs are configured for current environment
export function validateStripeConfiguration(requiredIds: string[]): {
  valid: boolean;
  missing: string[];
} {
  const missing: string[] = [];

  for (const id of requiredIds) {
    const priceId = getStripePriceId(id);
    if (!priceId) {
      missing.push(id);
    }
  }

  return {
    valid: missing.length === 0,
    missing
  };
}

// Get all configured Stripe price IDs for current environment
export function getAllStripePriceIds(): Record<string, string | null> {
  const env = getEnvironmentTier();
  return STRIPE_PRICES_MAP[env] || {};
}